import React from "react";
import { Accordion } from "react-bootstrap";
import { FAQ_ITEMS } from "./helpContent";

export default function HelpAccordion() {
  return (
    <Accordion
      alwaysOpen
      style={{ borderRadius: "10px", border: "2px solid #4a4a4a" }}
    >
      {FAQ_ITEMS.map((item) => (
        <Accordion.Item eventKey={item.id} key={item.id}>
          <Accordion.Header>{item.question}</Accordion.Header>
          <Accordion.Body>{item.answer}</Accordion.Body>
        </Accordion.Item>
      ))}
    </Accordion>
  );
}
